import { useLayoutEffect, useState } from 'react'

const useWindowPosition = () => {
  const [scrollPosition, setPosition] = useState(0)
  useLayoutEffect(() => {
    let timeoutId = null
    function updatePosition() {
      clearTimeout(timeoutId)
      timeoutId = setTimeout(() => setPosition(window.pageYOffset), 10)
    }
    window.addEventListener('scroll', updatePosition)

    return () => window.removeEventListener('scroll', updatePosition)
  }, [])
  return scrollPosition
}

export default useWindowPosition
